// import React, { useState } from 'react';
import { Form, Input, Button, Layout, Typography, Spin } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import './RestorePassword.css';

const { Content } = Layout;
const { Title, Text } = Typography;

const RestorePassword = ({ onSubmit, onBack, loading, error }) => {
  const [form] = Form.useForm();

  const handleFinish = (values) => {
    onSubmit(values.email);
  };

  return (
    <Layout className="restore-password-layout">
      <Content className="restore-password-content">
        <div className="header-section">
          <div />
          {/* <GlobalOutlined className="lang-icon" /> */}
        </div>

        <div className="status-hero">
          <Text className="domain-text">ACCESO DE SEGURIDAD</Text>
          <div className="hero-title">
            <Title level={1} className="main-title">
              Recuperar acceso<br />atmosférico.
            </Title>
            <Text className="description-text">
              Ingresa tu correo electrónico y te enviaremos las instrucciones necesarias para restablecer tu cuenta y continuar gestionando tus activos de carbono.
            </Text>
          </div>
        </div>

        <div className="form-card">
          <Form
            form={form}
            layout="vertical"
            onFinish={handleFinish}
            autoComplete="off"
            requiredMark={false}
          >
            <Form.Item
              label={<span className="input-label">CORREO ELECTRÓNICO CORPORATIVO</span>}
              name="email"
              rules={[
                { required: true, message: 'Por favor ingresa tu correo' },
                { type: 'email', message: 'Ingresa un correo válido' }
              ]}
            >
              <Input 
                placeholder="nombre@egreen.com" 
                bordered={false} 
                className="ant-input-underlined"
                disabled={loading}
              />
            </Form.Item>

            {error && (
              <div style={{ 
                color: '#ff4d4f', 
                marginBottom: '16px',
                padding: '8px 12px',
                background: '#fff2f0',
                border: '1px solid #ffccc7',
                borderRadius: '4px'
              }}>
                {error}
              </div>
            )}

            <Form.Item>
              {loading ? (
                <div style={{ textAlign: 'center', padding: '10px' }}>
                  <Spin />
                </div>
              ) : (
                <Button 
                  type="primary" 
                  htmlType="submit" 
                  block 
                  className="btn-primary custom-btn-celestial"
                >
                  Enviar Instrucciones <span className="arrow-icon"> &gt; </span>
                </Button>
              )}
            </Form.Item>

            <Form.Item>
              <Button 
                type="text" 
                block 
                className="btn-secondary"
                icon={<ArrowLeftOutlined />}
                onClick={onBack}
                disabled={loading}
              >
                Regresar al Login
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Content>
    </Layout>
  );
};

export default RestorePassword;
